import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApAmountsValidator {
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([Validators.pattern(/^[0-9,.-]+$/)])(control);
    }
}
